(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["unbroken-commerce-tools"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.UnbrokenCommerceTools) {
    window.UnbrokenCommerceTools.refresh();
    return;
  }

  var wishlistKey = 'unbroken_wishlist_v1';
  var recentKey = 'unbroken_recent_v1';

  function readList(key) {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(key) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeList(key, list) {
    try {
      window.localStorage.setItem(key, JSON.stringify(list));
      return true;
    } catch (error) {
      return false;
    }
  }

  function sameId(a, b) {
    return String(a) === String(b);
  }

  function currentProduct() {
    var node = document.querySelector('[data-ub-product-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function productExists(list, id) {
    return list.some(function (item) {
      return item && sameId(item.id, id);
    });
  }

  function addRecent(product) {
    if (!product || !product.id) return;
    var list = readList(recentKey).filter(function (item) {
      return item && !sameId(item.id, product.id);
    });
    list.unshift(product);
    writeList(recentKey, list.slice(0, 8));
  }

  function makeCard(product, removeLabel, removable) {
    var card = document.createElement('article');
    card.className = 'ub-commerce-card';

    var imageLink = document.createElement('a');
    imageLink.className = 'ub-commerce-card__image-link';
    imageLink.href = product.url || '#';
    imageLink.setAttribute('aria-label', product.title || '');

    if (product.image) {
      var image = document.createElement('img');
      image.className = 'ub-commerce-card__image';
      image.src = product.image;
      image.alt = product.title || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      imageLink.appendChild(image);
    }

    var meta = document.createElement('div');
    meta.className = 'ub-commerce-card__meta';

    var title = document.createElement('a');
    title.className = 'ub-commerce-card__title';
    title.href = product.url || '#';
    title.textContent = product.title || '';

    var price = document.createElement('p');
    price.className = 'ub-commerce-card__price';
    price.textContent = product.price || '';

    meta.appendChild(title);
    if (product.price) meta.appendChild(price);

    if (removable) {
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'ub-commerce-card__remove';
      remove.textContent = removeLabel || 'Remove';
      remove.addEventListener('click', function () {
        var list = readList(wishlistKey).filter(function (item) {
          return item && !sameId(item.id, product.id);
        });
        writeList(wishlistKey, list);
        refresh();
      });
      meta.appendChild(remove);
    }

    card.appendChild(imageLink);
    card.appendChild(meta);
    return card;
  }

  function updateWishlistControls() {
    var list = readList(wishlistKey);
    var count = list.length;

    document.querySelectorAll('[data-ub-wishlist-toggle]').forEach(function (button) {
      var id = button.getAttribute('data-product-id');
      var saved = productExists(list, id);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = button.querySelector('[data-ub-wishlist-label]');
      if (label) {
        label.textContent = saved
          ? button.getAttribute('data-saved-label')
          : button.getAttribute('data-add-label');
      }

      if (button.getAttribute('data-ub-bound') !== 'true') {
        button.setAttribute('data-ub-bound', 'true');
        button.addEventListener('click', function () {
          var product = currentProduct();
          if (!product || !product.id) return;
          var updated = readList(wishlistKey);
          var alreadySaved = productExists(updated, product.id);

          if (alreadySaved) {
            updated = updated.filter(function (item) {
              return item && !sameId(item.id, product.id);
            });
          } else {
            updated.unshift(product);
          }

          writeList(wishlistKey, updated.slice(0, 40));
          refresh();
        });
      }
    });

    document.querySelectorAll('[data-ub-wishlist-view]').forEach(function (link) {
      var base = link.getAttribute('data-base-label') || '';
      link.textContent = count > 0 ? base + ' (' + count + ')' : base;
    });
  }

  function renderRecentlyViewed() {
    document.querySelectorAll('[data-ub-recent-section]').forEach(function (section) {
      var grid = section.querySelector('[data-ub-recent-grid]');
      if (!grid) return;
      var current = currentProduct();
      var list = readList(recentKey).filter(function (item) {
        return item && (!current || !sameId(item.id, current.id));
      }).slice(0, 4);

      grid.innerHTML = '';
      if (!list.length) {
        section.hidden = true;
        return;
      }

      list.forEach(function (item) {
        grid.appendChild(makeCard(item, '', false));
      });
      section.hidden = false;
    });
  }

  function renderWishlistPage() {
    document.querySelectorAll('[data-ub-wishlist-page]').forEach(function (section) {
      var grid = section.querySelector('[data-ub-wishlist-grid]');
      var empty = section.querySelector('[data-ub-wishlist-empty]');
      if (!grid || !empty) return;

      var list = readList(wishlistKey);
      grid.innerHTML = '';

      if (!list.length) {
        grid.hidden = true;
        empty.hidden = false;
        return;
      }

      grid.hidden = false;
      empty.hidden = true;
      var removeLabel = section.getAttribute('data-remove-label') || 'Remove';

      list.forEach(function (item) {
        grid.appendChild(makeCard(item, removeLabel, true));
      });
    });
  }

  function refresh() {
    var product = currentProduct();
    if (product && product.id) addRecent(product);
    updateWishlistControls();
    renderRecentlyViewed();
    renderWishlistPage();
  }

  window.UnbrokenCommerceTools = {
    refresh: refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  document.addEventListener('shopify:section:load', refresh);
})();
  } catch(e) { console.error(e); }
})();

})();
